module.exports = __webpack_public_path__ + "img/lvlCertificate.60e905e3.png";